import { useQuery } from "@tanstack/react-query";
import useApi from "../utils/useApi";

export default function useUnlinkedCollections(enabled = true) {
  const { getUnlinkedCollections } = useApi();
  const { data, isLoading } = useQuery({
    queryKey: ["unlinkedCollections"],
    queryFn: () => getUnlinkedCollections(),
    enabled: Boolean(enabled),
  });

  const unlinkedCollections = data?.data;

  return { data: unlinkedCollections, isLoading };
}
